import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const IdCard = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path
        d="M16.4801 16H7.52012C7.16113 16 6.87012 16.291 6.87012 16.65V16.75C6.87012 17.109 7.16113 17.4 7.52012 17.4H16.4801C16.8391 17.4 17.1301 17.109 17.1301 16.75V16.65C17.1301 16.291 16.8391 16 16.4801 16Z"
        fill="black"
      />
      <Path
        d="M16.22 3H7.78C5.14 3 3 5.14 3 7.78V16.22C3 18.86 5.14 21 7.78 21H16.22C18.86 21 21 18.86 21 16.22V7.78C21 5.14 18.86 3 16.22 3ZM19.5 16.22C19.5 18.03 18.03 19.5 16.22 19.5H7.78C5.97 19.5 4.5 18.03 4.5 16.22V7.78C4.5 5.97 5.97 4.5 7.78 4.5H16.22C18.03 4.5 19.5 5.97 19.5 7.78V16.22Z"
        fill={color}
      />
      <Path
        d="M12.0005 14.27C14.0805 14.27 15.7705 12.58 15.7705 10.5C15.7705 8.41998 14.0805 6.72998 12.0005 6.72998C9.92047 6.72998 8.23047 8.41998 8.23047 10.5C8.23047 12.58 9.92047 14.27 12.0005 14.27ZM12.0005 8.28998C12.6605 8.28998 13.2005 8.82998 13.2005 9.48998C13.2005 10.15 12.6605 10.69 12.0005 10.69C11.3405 10.69 10.8005 10.15 10.8005 9.48998C10.8005 8.82998 11.3405 8.28998 12.0005 8.28998ZM11.2705 10.96H12.7205C13.4205 10.96 13.9805 11.52 13.9805 12.22C13.9805 12.38 13.9105 12.52 13.7905 12.62C13.3005 13.03 12.6705 13.28 11.9905 13.28C11.3105 13.28 10.6705 13.03 10.1905 12.62C10.0705 12.52 10.0005 12.37 10.0005 12.22C10.0005 11.52 10.5705 10.96 11.2605 10.96H11.2705Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default IdCard
